// extracted by mini-css-extract-plugin
export default {"statuses-menu-item":"menu_statuses-menu-item__l1Tyy","statuses-menu-separator":"menu_statuses-menu-separator__JXTwg"};